import { render, staticRenderFns } from "./CampaignSettingsModal.vue?vue&type=template&id=32fa3a9c"
import script from "./CampaignSettingsModal.vue?vue&type=script&lang=js"
export * from "./CampaignSettingsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports